import Vue from 'vue';

export default {
  data() {
    return {
      stoppedVehicleIcon: require('@/assets/images/stop_icon.svg'),
    };
  },
  methods: {
    toRadians(degrees) {
      return (degrees * Math.PI) / 180;
    },
    // Converts from radians to degrees.
    toDegrees(radians) {
      return (radians * 180) / Math.PI;
    },
    bearing(startLat, startLng, destLat, destLng) {
      startLat = this.toRadians(startLat);
      startLng = this.toRadians(startLng);
      destLat = this.toRadians(destLat);
      destLng = this.toRadians(destLng);
      const y = Math.sin(destLng - startLng) * Math.cos(destLat);
      const x =
        Math.cos(startLat) * Math.sin(destLat) -
        Math.sin(startLat) * Math.cos(destLat) * Math.cos(destLng - startLng);
      let brng = Math.atan2(y, x);
      brng = this.toDegrees(brng);
      return (brng + 360) % 360;
    },
    getCurrentLocationTime: function (date) {
      return Vue.moment(date).format('jYYYY/jMM/jDD-HH:mm:ss');
    },
  },
};
